import React from 'react';

//CORE COMPONENTS
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root';
import {
    ThemeProvider,
    styled
} from '../../../components-core/packages/components-core/dist/theme-provider';
import { Image } from '../../../components-core/packages/components-core/dist/image';
import { Text, TextAppearance, TextColor, TextAlignment } from '../../../components-core/packages/components-core/dist/text';
import GoogleMapReact from 'google-map-react';

//BUTTON
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';
import { Link } from '../../../components-core/packages/components-core/dist/link';

//LAYOUT
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerVerticalAlignment,
    ContainerHorizontalAlignment,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container';
import { Layout, LayoutConfigurations } from '../../../components-core/packages/components-core/dist/layout';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { LayerWrapper } from '../../../components-core/packages/components-core/dist/layer-wrapper';
import { InteractionLayer, InteractionLayerSize } from '../../../components-core/packages/components-core/dist/interaction-layer';
import { TextInput, TextInputAppearance } from '../../../components-core/packages/components-core/dist/text-input';
//ICONS
import { Close } from '../../../components-core/packages/icons-core/dist/Close';
import { Phone } from '../../../components-core/packages/icons-core/dist/Phone';
import { Mail } from '../../../components-core/packages/icons-core/dist/Mail';
import { Magnifier } from '../../../components-core/packages/icons-core/dist/Magnifier'

import './BreadCrumb.css'

class BreadCrumb extends React.Component { 

    constructor() {
        super();
        this.state = {
        }
    }

    render() {
        return (
            <div class="grid">
            <div class="container">
                <ol class="breadcrumb">
                    <li><a href="#">Home</a></li>
                    <li><a href="#">San Pedro de Atacama</a></li>
                    <li class="active relative drop-container">
                        <span href="#">Geysers del Tatio (Standard) <span class="glyphicon glyphicon-triangle-bottom small" aria-hidden="true"></span></span>
                        <div class="drop bg-white">
                            <ul class="list pl0">
                                <li><a href="#">Geysers del Tatio (Superior)</a></li>
                                <li><a href="#">Geysers del Tatio (Lujo)</a></li>
                            </ul>
                        </div>
                    </li>
                </ol>
            </div>
        </div>
        )
    }


}

export default BreadCrumb;
